import React, { useContext } from 'react'
import CompactWorkItem from '@Components/WorkItemV2/CompactWorkItem'
import WorkItemData from '@Components/WorkItemV2/work-item-data'
import ShareDisplay from '@Components/WorkItemV2/ShareDisplay'
import StatusComponent from '@Components/Status'
import HistoryCompactWorkItemHeader from '@Components/WorkItemV2/History/HistoryCompactWorkItem/HistoryCompactWorkItemHeader'
import './index.scss'
import { CardWithHeader } from '@Components/Tables/CardResults/card-with-header'
import { getSubmissionPath } from '@App/helpers/get-submission-path'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'

const HistoryCompactWorkItem: CardWithHeader<WorkItemData> = (props: WorkItemData) => {
    const { rightsholderStore } = useContext<RootStore>(StoresContext)
    const submissionPath = getSubmissionPath(rightsholderStore.currentRightsholderId, props.work.id, props.fetchType)
    return (
        <CompactWorkItem work={props.work} className="history-work-item" catalogPath={submissionPath}>
            <div className="shares-group">
                <ShareDisplay share={props.work.totalKnownShares} title="" highlight />
            </div>
            {props.work.registrationHistoryStatus && (
                <StatusComponent
                    status={
                        props.work.registrationHistoryStatus === 'Unknown'
                            ? 'Submitted'
                            : props.work.registrationHistoryStatus
                    }
                />
            )}
        </CompactWorkItem>
    )
}

HistoryCompactWorkItem.headerType = HistoryCompactWorkItemHeader

export default HistoryCompactWorkItem
